var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("v-data-table", {
        staticClass: "my-1 levation-2 myDense",
        attrs: {
          headers: _vm.headers,
          items: _vm.upcs,
          search: _vm.filter,
          pagination: _vm.pagination,
          "select-all": "",
          "rows-per-page-items": _vm.rowPerPage,
          "item-key": "upc"
        },
        on: {
          "update:pagination": function($event) {
            _vm.pagination = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "items",
            fn: function(props) {
              return [
                _c(
                  "tr",
                  { class: props.item.unstowedQty < 0 ? "abnormal_list" : "" },
                  [
                    _c(
                      "td",
                      {
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.onClickItem(props)
                          }
                        }
                      },
                      [
                        props.item.unstowedQty || _vm.type === "pickup"
                          ? _c("v-checkbox", {
                              attrs: {
                                "input-value": props.selected,
                                primary: "",
                                "hide-details": ""
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { staticClass: "subheading" },
                      [
                        _c(
                          "v-layout",
                          { staticClass: "text-sm-left" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(props.item.upc) +
                                "\n            "
                            ),
                            props.item.isPackageManagement
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "div",
                                                _vm._g({}, data.on),
                                                [
                                                  _c(
                                                    "v-icon",
                                                    { staticClass: "ml-1" },
                                                    [_vm._v("widgets")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$t("isThePackage")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(_vm._s(props.item.productName))
                    ]),
                    _vm._v(" "),
                    _vm.type === "stow"
                      ? _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            _vm._s(props.item.unstowedQty) +
                              " / " +
                              _vm._s(props.item.totalQty)
                          )
                        ])
                      : _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(_vm._s(props.item.totalQty))
                        ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "text-xs-left" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.item.location.join(", ")) +
                          "\n        "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.type === "stow"
                      ? _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c(
                              "v-layout",
                              {
                                attrs: {
                                  row: "",
                                  "justify-center": "",
                                  "align-baseline": ""
                                }
                              },
                              [
                                props.selected
                                  ? _c(
                                      "v-flex",
                                      { attrs: { xs3: "" } },
                                      [
                                        _c("v-text-field", {
                                          staticClass: "table-item",
                                          attrs: {
                                            "hide-details": "",
                                            mask: "#####"
                                          },
                                          model: {
                                            value: _vm.stowMap[props.item.upc],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.stowMap,
                                                props.item.upc,
                                                _vm._n($$v)
                                              )
                                            },
                                            expression:
                                              "stowMap[props.item.upc]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { xs6: "" } },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          dark: "",
                                          color: "primary",
                                          flat: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.$$showEditLocationDialog(
                                              props.item
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("edit")))]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                )
              ]
            }
          }
        ]),
        model: {
          value: _vm.selectedUpcs,
          callback: function($$v) {
            _vm.selectedUpcs = $$v
          },
          expression: "selectedUpcs"
        }
      }),
      _vm._v(" "),
      _c("FormSubmitPopup", {
        attrs: {
          hasAlert: "",
          title: _vm.$t("editLocation"),
          rightMethod: _vm.editLocation,
          medium: ""
        },
        on: {
          popupClose: function() {
            _vm.editLocationDialog = false
          }
        },
        scopedSlots: _vm._u([
          {
            key: "input",
            fn: function() {
              return [
                _c(
                  "v-alert",
                  {
                    attrs: { dismissible: "", type: "success" },
                    model: {
                      value: _vm.hasMessage,
                      callback: function($$v) {
                        _vm.hasMessage = $$v
                      },
                      expression: "hasMessage"
                    }
                  },
                  [_vm._v(_vm._s(_vm.submitMessage))]
                ),
                _vm._v(" "),
                _c("v-layout", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("siteName") +
                        ": " +
                        _vm.getSiteNameFromKey(_vm.siteKey)
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: { label: "UPC", id: "upc" },
                          on: { change: _vm.onUpdateUpc },
                          model: {
                            value: _vm.upcInEdit.upc,
                            callback: function($$v) {
                              _vm.$set(_vm.upcInEdit, "upc", $$v)
                            },
                            expression: "upcInEdit.upc"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-layout", [
                  _vm._v(
                    _vm._s(
                      _vm.$t("productName") +
                        ": " +
                        (_vm.upcInEdit.productName || "N/A")
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      [
                        _c("v-combobox", {
                          ref: "combobox",
                          attrs: {
                            chips: "",
                            multiple: "",
                            "deletable-chips": "",
                            clearable: ""
                          },
                          model: {
                            value: _vm.upcInEdit.location,
                            callback: function($$v) {
                              _vm.$set(_vm.upcInEdit, "location", $$v)
                            },
                            expression: "upcInEdit.location"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ]),
        model: {
          value: _vm.editLocationDialog,
          callback: function($$v) {
            _vm.editLocationDialog = $$v
          },
          expression: "editLocationDialog"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38b882f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38b882f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WarehouseStowTable.vue
// module id = null
// module chunks = 